import { Button } from "@roberttamas/ui";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Check, Copy } from "@/components/icons";

interface Props {
  value: string;
  label?: string;
}

export function CopyButton({ value, label }: Props) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const id = window.setTimeout(() => setCopied(false), 1500);
    return () => window.clearTimeout(id);
  }, [copied]);

  const onClick = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch {
      /* ignore */
    }
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label={label ?? t("common.copy")}
      onClick={onClick}
      className="h-7 w-7"
    >
      {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
    </Button>
  );
}
